module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('ul', {
    staticClass: "progressbar"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('li', {
      class: _vm.currentStep >= index ? 'active' : ''
    }, [_vm._v(_vm._s(step))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76df5003!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressStepper.vue
// module id = 416
// module chunks = 2